import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/calendar',
	title:       'menu.agenda',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/calendar';
	},
});
